export const ShieldIcon = () => {
  return (
    <i className='material-symbols-shield-outline-rounded align-middle text-xl m-[2px] bg-(--mui-palette-primary-main)' />
  );
};
